
import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  computed: {
    rangeText() {
      if (this.currentMin == this.min && this.currentMax == this.max) {
        return `${this.label} indifférent` + (this.labelGenderIsF ? 'e' : '');
      }
      if (this.currentMin == this.min) {
        return `${this.label} inférieur${
          this.labelGenderIsF ? 'e' : ''
        } à <strong>${this.formatNumericValue(this.currentMax)} ${
          this.unit
        } </strong>`;
      }
      if (this.currentMax == this.max) {
        return `${this.label} supérieur${
          this.labelGenderIsF ? 'e' : ''
        } à <strong>${this.formatNumericValue(this.currentMin)} ${
          this.unit
        } </strong>`;
      }
      return `${this.label}  entre <strong> ${this.formatNumericValue(
        this.currentMin
      )} ${this.unit} et ${this.formatNumericValue(this.currentMax)} ${
        this.unit
      } </strong>`;
    },
  },
  props: {
    id: {
      type: String,
      default() {
        return `slider-input-${this._uid}`;
      },
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 100,
    },
    label: {
      type: String,
      default: '',
    },
    state: {
      type: Number,
      default: 1,
    },
    labelGenderIsF: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: '',
    },
    error: String,
  },
  data() {
    return {
      slider: {
        step: 1,
      },
      currentMin: this.$attrs.value[0],
      currentMax: this.$attrs.value[1],
    };
  },
  mounted() {
    noUiSlider.create(this.$refs.slider, {
      connect: [false, true, false],
      start: [this.$attrs.value[0], this.$attrs.value[1]],
      step: this.step,
      range: {
        min: this.min,
        max: this.max,
      },
    });

    this.$refs.slider.noUiSlider.on('update', (values, handle) => {
      this.$emit('input', values);
      this.currentMin = values[0];
      this.currentMax = values[1];
    });
  },
  watch: {
    state: function (newVal, oldVal) {
      // force reset
      this.$refs.slider.noUiSlider.updateOptions(
        {
          connect: [false, true, false],
          start: [this.$attrs.value[0], this.$attrs.value[1]],
          step: this.step,
          range: {
            min: this.min,
            max: this.max,
          },
        },
        true
      );
      this.currentMin = this.$attrs.value[0];
      this.currentMax = this.$attrs.value[1];
    },
  },
};
